import { createContext, useContext } from 'react';

import type { Borrower } from '@willow/graphql-iso/src/app';
import { assertNotNull } from '@willow/shared-iso';
import type { BorrowerId } from '@willow/types-iso';

interface WorkflowLoanContext {
  borrowersById: Map<BorrowerId, Borrower>;
}

export const WorkflowLoanContext = createContext<WorkflowLoanContext | undefined>(undefined);

/**
 * Provides loan context necessary to render form elements that depend on loan data.
 */
export const useWorkflowLoanContext = (): WorkflowLoanContext =>
  assertNotNull(useContext(WorkflowLoanContext), 'useWorkflowLoanContext must be used within a WorkflowLoanContext');
